window.addEventListener("load", function() {
    const tabPanels = document.querySelectorAll(".services-panel");

    for (const tabPanel of tabPanels) {
        const tabButtons = tabPanel.querySelectorAll('button[data-tab]');
        const tabContent = tabPanel.querySelector('[data-tab-content]');
        let locked = false;

        // Set initial container widths
        const buttonContainers = tabPanel.querySelectorAll('div[data-container="button"]');
        buttonContainers.forEach(container => {
            const button = container.querySelector('button');
            if (button) {
                container.style.width = `${button.offsetWidth}px`;
            }
        });

        tabPanel.addEventListener('click', function (event) {
            const button = event.target.closest('button[data-tab]');
            if (!!locked) return;

            if (button) {
                const clickedTab = button.dataset.tab;
                const currentActiveTab = tabContent.querySelector('[data-tab-active="true"]');
                const currentActiveTabColour = currentActiveTab?.dataset.tabColour;
                const currentActiveTabIndex = currentActiveTab?.dataset.tab;
                const currentActiveTabTitle = currentActiveTab?.querySelector('h3')?.innerText.toUpperCase();

                // Reset all tabs
                const allTabs = tabContent.querySelectorAll('[data-tab]');

                allTabs.forEach(tab => {
                    tab.dataset.tabActive = 'false';
                });

                tabButtons.forEach(button => {
                    button.dataset.active = 'false';
                });

                //get clone size
                const cloneSizer = button.cloneNode(true);
                // Temporarily insert clone off-screen to measure it
                cloneSizer.style.position = 'absolute';
                cloneSizer.style.visibility = 'hidden';
                cloneSizer.style.pointerEvents = 'none';
                document.body.appendChild(cloneSizer);
                const oldWidth = cloneSizer.offsetWidth;
                cloneSizer.innerText = currentActiveTabTitle;
                const newWidth = cloneSizer.offsetWidth;
                document.body.removeChild(cloneSizer);

                // Clone the active button
                const clone = button.cloneNode(true);
                const buttonContainer = button.closest('div[data-container="button"]');
                button.dataset.cloned = 'true';
                if (newWidth >= oldWidth) {
                    buttonContainer.style.width = `${newWidth}px`;
                } else {
                    setTimeout(() => {
                        buttonContainer.style.width = `${newWidth}px`;
                    }, 1000);
                }
                buttonContainer.prepend(clone);
                clone.style.color = currentActiveTabColour;
                clone.innerText = currentActiveTabTitle;
                clone.dataset.tab = currentActiveTabIndex;

                clone.dataset.freshClone = 'true';
                setTimeout(() => {
                    clone.dataset.freshClone = 'false';
                }, 50);

                setTimeout(() => {
                    button.remove();
                }, 1000);

                button.dataset.active = 'true';

                // Activate the clicked tab
                const activeTabs = tabContent.querySelectorAll(`[data-tab="${clickedTab}"]`);
                activeTabs.forEach(activeTab => {
                    activeTab.dataset.tabActive = 'true';
                });

                locked = true;
                setTimeout(() => {
                    locked = false;
                }, 900);
            }
        });
    }
});
